// extracted by mini-css-extract-plugin
export var label = "_62-5";
export var slideContainer = "_62-0";
export var slider = "_62-1";
export var sliderLg = "_62-4";
export var sliderMd = "_62-3";
export var sliderSm = "_62-2";